// Function for svg sprite
function requireAll(r) {
    r.keys().forEach(r);
}
requireAll(require.context('../images/sprite-images/', true, /\.svg$/));


//Modification comments 
const commentModerations = document.querySelectorAll('.comment-awaiting-moderation');

commentModerations.forEach(commentModeration => {
    commentModeration.parentElement.classList.add('comment-body--moderation');
})

if (document.querySelector('.home')) {
    // Home select Annuaire
    if (document.body.classList.contains('home')) {
        const annuaireBtn = document.querySelector('.annuaire__btn');

        annuaireBtn.addEventListener('click', () => {
            let urlAnnuaire = document.getElementById('annuaire__category').value;

            if ( urlAnnuaire != '#' ) {
                window.location.href = urlAnnuaire;
            }
        });
    }

    // Remplacer le texte du select et du bouton fiche contact Annuaire en 640
    if (window.innerWidth <= 640) {
        // Select 
        const selectElement = document.getElementById("annuaire__category");
        const firstOptionElement = selectElement.options[0];
        
        firstOptionElement.text = "Catégorie";

        // Button fiche contact
        const buttonElement = document.querySelector(".annuaire__button"); 
        const textContent = buttonElement.childNodes[0].textContent; // récupérer le texte du bouton
        const svgElement = buttonElement.querySelector("svg"); // sélectionner l'élément SVG à l'intérieur du bouton

        buttonElement.innerHTML = ""; // vider le contenu du bouton
        buttonElement.appendChild(document.createTextNode("Créez votre fiche ")); // ajouter le nouveau texte "Créez votre fiche"
        buttonElement.appendChild(svgElement); // ajouter l'élément SVG à l'intérieur du bouton
    }
}
